import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
// G360_ICONS_LOCAL - the Tabler icon font is bundled rather than fetched
// from a CDN at runtime. Removes a third-party dependency, and with it the
// sourcemap request that CSP blocked on every page load.
import '@tabler/icons-webfont/dist/tabler-icons.min.css';

// G360_K684 - a tab opened before a deploy still asks for the page files of the build it loaded, and
// their names change on every build. Netlify answers a missing file with the home page, the browser
// refuses that as a script, and the console went white. When a page file cannot be loaded the console
// now reloads once, which picks up the new build. A second failure within 20 seconds is not reloaded
// again, so a real outage cannot loop; the error then shows as it did before.
const STALE = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;
function reloadOnce() {
  let last = 0;
  try { last = Number(window.sessionStorage.getItem('g360-stale-reload') || 0); } catch (e) { return false; }
  if (Date.now() - last < 20000) return false;
  try { window.sessionStorage.setItem('g360-stale-reload', String(Date.now())); } catch (e) { return false; }
  window.location.reload();
  return true;
}
function staleMessage(x) {
  if (!x) return '';
  return String(x.message || (x.reason && (x.reason.message || x.reason)) || (x.error && x.error.message) || x);
}
window.addEventListener('vite:preloadError', (e) => { if (reloadOnce()) e.preventDefault(); });
window.addEventListener('unhandledrejection', (e) => { if (STALE.test(staleMessage(e.reason))) reloadOnce(); });
window.addEventListener('error', (e) => { if (STALE.test(staleMessage(e))) reloadOnce(); });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
